module.exports = __webpack_public_path__ + "img/202402_04.f86addc7.jpg";